export enum NotificationCategoryType {
  Marketing = 'marketing',
  OrderStatus = 'order-status',
}
